import { render, staticRenderFns } from "./DependencyApplicationsSingleVulnerabilities.vue?vue&type=template&id=bf47ef3a&"
import script from "./DependencyApplicationsSingleVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./DependencyApplicationsSingleVulnerabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports